@import "~@uipath/apollo-core/src/scss/base-host.scss";

@import url("https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined");

.menu-item-base {
  display: flex;
  font-family: $font-normal;
  font-style: normal;
  font-weight: normal;
  font-size: $font-m-size;
  line-height: $font-m-line-height;
  color: var(--color-foreground-de-emp);
  padding: 0 $pad-xxxl;
  border: none;
  background: none;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 400px;
  text-align: left;
  &.break-top {
    border-top: $stroke-s solid var(--color-border);
  }

  &.break-bottom {
    border-bottom: $stroke-s solid var(--color-border);
  }

  &.disabled {
    cursor: default;
    user-select: none;
    color: var(--color-foreground-disable);
    .menu-item-icon {
      color: var(--color-foreground-disable);
    }
  }

  .menu-text-group {
    display: flex;
    flex-direction: column;

    justify-content: center;
    padding-right: $pad-xxxl;
    width: 100%;
    cursor: var(--cursor);
  }

  .menu-text {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .menu-item-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 24px;
    width: $icon-m;
    margin-right: $pad-xl;
    line-height: 12px;
    color: var(--color-foreground-de-emp);
    .material-icons {
      font-size: $icon-m;
    }
  }

  &:not(:disabled):not(.disabled).primary{
    color: var(--color-primary);
    .menu-item-icon{
      color: var(--color-primary);
    }
  }

  &:not(:disabled):not(.disabled).error{
    color: var(--color-error-text);
    .menu-item-icon{
      color: var(--color-error-icon);
    }
  }

  &:not(:disabled):not(.disabled):hover {
    background-color: var(--color-hover);
    cursor: var(--cursor);
    background-position: 100% 0;
  }

  &.menu-active {
    background-color: var(--color-hover);
  }
}
